import MediaObjectCreate from './MediaObjectCreate';
import MediaObjectList from './MediaObjectList';

export default {
  create: MediaObjectCreate,
  list: MediaObjectList,
};
